import type { AskPageContext } from "../types/chat.types";

/** Fixed agent-loop prompts for GTM empty state (story 12.4). Not managing-prompt catalog entries. */
export interface GtmAskStarter {
  id: "last-run" | "dismissed" | "who-to-contact";
  /** Stable English prompt sent as turn content. */
  prompt: string;
  /** Short chip label for the UI. */
  label: string;
}

/**
 * Read-oriented starters. Copy uses “dismissed” (not “rejected”) — candidate DTOs
 * may not expose rich reject reasons.
 */
export const GTM_ASK_STARTERS: readonly GtmAskStarter[] = [
  {
    id: "last-run",
    label: "How did this Play’s last run go?",
    prompt:
      "How did this Play’s last run go? Use get-play and get-lead-search for the active play (do not call list-plays first).",
  },
  {
    id: "dismissed",
    label: "Why were candidates dismissed?",
    prompt:
      "Why were candidates dismissed for this Play? Use list-lead-candidates with status=dismissed for the active play.",
  },
  {
    id: "who-to-contact",
    label: "Which leads should I contact first?",
    prompt:
      "Which leads should I contact first on this Play? Use list-lead-candidates for found candidates and rank heuristically. Stay read-only unless I explicitly ask to approve or find leads.",
  },
] as const;

export function isGtmAskPageKind(
  ctx: AskPageContext | null | undefined
): ctx is Extract<AskPageContext, { kind: "gtm-play" | "gtm-brain" }> {
  return ctx?.kind === "gtm-play" || ctx?.kind === "gtm-brain";
}
